export default {
  _default: `Qillqataxa janiwa walikiti.`,
  alpha_dash: `Qillqaña suyunxa utjañapakiwa qillqanakampi jaqhunakampi sirqinakampi.`,
  alpha_num: `Qillqaña suyunxa utjañapakiwa qillqanakampi jaqhunakampi.`,
  alpha_spaces: `Qillqaña suyunxa utjañapakiwa qillqanakampi ch'usawja suyunakampi.`,
  alpha: `Qillqaña suyunxa utjañapakiwa qillqanakäki.`,
  between: `Qillqaña suyuxa debe estar entre {min} y {max}.`,
  confirmed: `Qillqaña suyuxa janiwa pachpakiti akampi {confirmedField}.`,
  credit_card: `Qillqaña suyxa janiwa chiqakiti.`,
  date_between: `El campo debe estar entre {min} y {max}.`,
  date_format: `Qillqaña suyuxa aka arkañapa {format}.`,
  decimal: `Qillqaña suyuxa jaqhukiñapawa ukatxa utjañapawa {decimals} decimal ch'aqa.`,
  digits: `Qillqaña suyuxa jaqhukiñapawa ukatxa utjañapawa jaqt'ata {length} dígitonaka.`,
  dimensions: `Qillqaña suyuxa wakichañatapawa {width} pixelanaka ukampisa {height} pixelanaka.`,
  email: `Qillqaña suyuxa chiqa correo electronicoñapawa.`,
  ext: `Qillqaña suyuxa mä  chiqa archivoñapawa.`,
  image: `Qillqaña suyuxa mä imagenañapawa.`,
  in: `Qillqaña suyuxa mä chiqa chaniñapawa.`,
  ip: `Qillqaña suyuxa mä chiqa ip irpawiñapawa.`,
  max: `Qillqaña suyuxa janiw jiliri chaniñapakiti {length} qillqa jaqhuwinakaru.`,
  max_value: `Qillqaña suyuxa pachpakiñapawa {length} jan ukaxa sullkañapawa.`,
  mimes: `Qillqaña suyuxa mä  chiqa kasta archivoñapawa.`,
  min: `Qillqaña suyuxa {length} qillqa jaqhuniñapawa.`,
  min_value: `Qillqaña suyuxa debe ser {length} o superior.`,
  not_in: `Qillqaña suyuxa debe ser un valor válido.`,
  numeric: `Qillqaña suyuxa debe contener solo caracteres númericos.`,
  regex: `El formato del campo no es válido.`,
  required: `Qillqaña suyuñaxa wayt'atawa.`,
  size: `Qillqaña suyuxa sullkaskañapawa {size} KB.`,
  url: `Qillqaña suyuxa janiwa mä URL chiqakiti.`
};



// WEBPACK FOOTER //
// ./src/common/lang/ay/validates.js